import { jsx as _jsx } from "react/jsx-runtime";
import WithSpeed from './WithSpeed/WithSpeed';
import WithoutSpeed from './WithoutSpeed/WithoutSpeed';
const ComparisonTableHeroV2Row = (props) => {
    const { showSpeedColumn } = props;
    return showSpeedColumn ? _jsx(WithSpeed, Object.assign({}, props)) : _jsx(WithoutSpeed, Object.assign({}, props));
};
export default ComparisonTableHeroV2Row;
